import { render, staticRenderFns } from "./HeadInfoSimple.vue?vue&type=template&id=6ed23daa&"
import script from "./HeadInfoSimple.vue?vue&type=script&lang=js&"
export * from "./HeadInfoSimple.vue?vue&type=script&lang=js&"
import style0 from "./HeadInfoSimple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/landun/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ed23daa')) {
      api.createRecord('6ed23daa', component.options)
    } else {
      api.reload('6ed23daa', component.options)
    }
    module.hot.accept("./HeadInfoSimple.vue?vue&type=template&id=6ed23daa&", function () {
      api.rerender('6ed23daa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/page/detail/components/HeadInfoSimple.vue"
export default component.exports